import React, { useEffect, useState } from 'react'
import FeatherIcon from 'feather-icons-react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { setGlobalLoading } from 'redux/actions/actionCommon';
import { connect } from 'react-redux';
import AppFormikInputInline from 'utlis/helpers/forms/AppFormikInputInline';
import LoadingSkeleton from './../../LoadingSkeleton';
import HTMLEditor from 'utlis/helpers/HTMLEditor';
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl';

function AddSelfPickUp(props) {
    const { formik } = props
    const [loading, setLoading] = useState(false)

    // store url
    const [storeUrl] = useStoreUrl()

    return (
        <React.Fragment>
            <section id="app-product-filters" className="st-def-mar-TB page-eorc-wrapper">
                <Container fluid className="st-container">
                    <div className="app-product-filters">
                        <div className="app-header-wrapper mb-3">
                            <div className="back-button-wrapper mb-2">
                                <Link to={storeUrl + "/settings/shippings"} className="text-decoration-none st-text-primary d-inline-flex align-items-center cursor-pointer st-fs-15">
                                    <FeatherIcon
                                        icon="arrow-left"
                                        size="14"
                                        className="icon me-1" />
                                    <span>Back</span>
                                </Link>
                            </div>
                            <p className="app-heading text-capitalize">Add Pickup Option</p>
                        </div>

                        <Row className="product-filter-left-content">
                            <Col lg={10} md={12} className="product-filter-right-content">
                                {loading ? <LoadingSkeleton
                                    height={600}
                                /> :
                                    <div>
                                        <div className="app-card mb-3 mb-lg-4">
                                            <div className="product-filter-card">
                                                <div className="card-content">
                                                    <Col lg={8} className="card-content">
                                                        <div className="d-flex flex-column">
                                                            <div className="card-text">
                                                                <div className="card-header_">
                                                                    <span>Order pickup label at checkout</span>
                                                                </div>
                                                                <div className="card-description">
                                                                    <AppFormikInputInline
                                                                        inputType={"text"}
                                                                        formik={props.formik} // formik object
                                                                        stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                                                                        labelName={""} // label name
                                                                        isRequired={true} // is this field is required or not to show the red star sign
                                                                        placeholder={"Self Pickup"} // placeholder for the input
                                                                        formikFieldName={"blogTitle"} // important: formik value name for the input
                                                                    />

                                                                </div>
                                                            </div>
                                                            <div className="card-text">
                                                                <div className="card-header_">
                                                                    <span>Detailed instructions for customers
                                                                    </span>
                                                                </div>
                                                                <div className="card-description">
                                                                    <div className={`st-form-with-label-left d-flex flex-wrap mb-3 `}>
                                                                        <div className="media-body">
                                                                            <HTMLEditor
                                                                            // defaultValue={formik.values.description}
                                                                            // getResult={getResult}
                                                                            />

                                                                            {
                                                                                /* form message */
                                                                                // (formik.touched.description && formik.errors.description) && (
                                                                                //     <div className="st-form-msg position-absolute" style={{ bottom: -18 }}>
                                                                                //         <p className="st-fs-12">{formik.errors.description}</p>
                                                                                //     </div>
                                                                                // )
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <p>Describe in details how, where, and when your customers will be able to pick up their order. They will see this information at checkout and in order notification emails.</p>
                                                                </div>
                                                            </div>
                                                            <div className="card-text mt-4">
                                                                <div className="card-header_">
                                                                    <span>Pickup charge</span>
                                                                </div>
                                                                <div className="card-description">
                                                                    <p>Add an extra charge for pickup if delivering an order with this pickup option causes additional expenses for you.</p>
                                                                    <p>The amount specified below will be added to the order total at checkout.</p>
                                                                    <AppFormikInputInline
                                                                        inputType={"text"}
                                                                        formik={props.formik} // formik object
                                                                        stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                                                                        labelName={""} // label name
                                                                        isRequired={true} // is this field is required or not to show the red star sign
                                                                        placeholder={"0.0"} // placeholder for the input
                                                                        formikFieldName={"blogTitle"} // important: formik value name for the input
                                                                    />

                                                                </div>
                                                            </div>
                                                            <div className="mb-4">
                                                                <div className="d-flex align-items-center">
                                                                    <div className="text__dark-color st-fs-16 st-fw-600 me-2 mt-2">Ask for pickup date and time at checkout</div>
                                                                    <label className="st-switch-input-xs st-switch-success d-inline-flex align-items-center mt-2">
                                                                        <input
                                                                            className="d-none"
                                                                            type="checkbox"
                                                                            name="switch"
                                                                            // checked={enabled ? false : true}
                                                                            onChange={e => {
                                                                                // setEnabled(e.target.value)
                                                                            }}
                                                                        />
                                                                        <span className="round-outer">
                                                                            <span className="round d-block">
                                                                            </span>
                                                                        </span>
                                                                    </label>
                                                                </div>
                                                                <p className="mt-2">Enable to add the Date and Time Picker for this pickup option at checkout. Customers will need to specify when they will be picking up their order.</p>
                                                            </div>
                                                            <div>
                                                                <div className="text__dark-color st-fs-16 st-fw-600 me-2 mb-2">Curbside or drive-through pickup</div>
                                                                <p>If you offer curbside or drive-through pickup instead of regular in-store pickup, change the pickup label displayed at checkout. And be sure to update the pickup instructions for customers to make it clear how that works exactly. For example: “When you’re at the pickup location, call us at [insert your phone number here], and we’ll safely place your order in your car’s trunk.”</p>
                                                            </div>
                                                            <div className="mt-3">
                                                                <button
                                                                    type="button"
                                                                    className="st-btn st-btn-primary st-fw-600 st-btn-xs text-capitalize d-flex align-items-center justify-content-center"
                                                                >
                                                                    <span>save</span>
                                                                </button>
                                                            </div>
                                                        </div>

                                                    </Col>
                                                </div>
                                            </div>
                                        </div>
                                    </div>}
                            </Col>
                        </Row>
                    </div>
                </Container>
            </section>
        </React.Fragment>
    )
}


const getDataFromStore = state => {
    return {
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(AddSelfPickUp)